export default __webpack_public_path__ + "static/media/santa-maria-11.892b4878.jpg";